import React from "react";
import {
  Card,
  CardImg,
  CardImgOverlay,
  CardBody,
  CardTitle,
  CardText,
} from "reactstrap";
import LoadComments from "./LoadComments";
import CommentsForm from "./CommentsForm";

function DishDetails(props) {
  return (
    <div>
      <Card style={{ margin: "20px" }}>
        <CardImg top src={props.dish.image} alt={props.dish.name} />
        <CardBody style={{ textAlign: "left" }}>
          <CardTitle>{props.dish.name}</CardTitle>
          <CardText>
            <p>{props.dish.description}</p>
            <p>{props.dish.price}</p>
          </CardText>
          <hr />
          <LoadComments comments={props.comments} />
          <hr />
          <CommentsForm dishId={props.dish.id} addComment={props.addComment} />
        </CardBody>
      </Card>
    </div>
  );
}

export default DishDetails;
